<ng-container *ngIf="servicePlan && hasContentForFeatureSection">
  <h3 class="d-none d-sm-block ds-heading--l mb-0">
    {{servicePlan.description ? servicePlan.description : servicePlan.name}}
  </h3>
  <div class="d-none d-sm-block w-100 separator my-4"></div>
  <dcp-checkmark-list *ngIf="servicePlan.features?.length" [entries]="servicePlan.features"></dcp-checkmark-list>
  <ng-container *ngIf="includedList?.length">
    <div *ngIf="servicePlan.features?.length" class="w-100 separator my-4"></div>
    <dcp-checkmark-list [entries]="includedList"></dcp-checkmark-list>
  </ng-container>
  <ng-container *ngIf="commitmentPeriod || restrictions?.length">
    <div *ngIf="servicePlan.features?.length || includedList?.length" class="w-100 separator my-4"></div>
    <dcp-checkmark-list
      [entries]="mergeArrays((commitmentPeriod ? [{value: (durationTranslationKey | cxTranslate:{
        min: commitmentPeriod.min?.toString(10),
        max: commitmentPeriod.max?.toString(10),
        unit: commitmentPeriod.unit?.name
      })}] : undefined), restrictions)"
      [useBoxIcon]="true"></dcp-checkmark-list>
  </ng-container>
</ng-container>
<ng-container *ngIf="termsConditionsProductEntries.length">
  <div class="w-100 separator my-4"></div>
  <dcp-terms-conditions [entry]="termsConditionsProductEntries[0]"
                        [entries]="termsConditionsProductEntries"
                        [pdpTerms]="{isPdpTerms: true, showIconLink: false}"
                        [isStoreHeaderShown]="true"
                        (termsConditionsLoadedNoData)="onNoEntryData($event)">
  </dcp-terms-conditions>
</ng-container>
